import popular from "./components/popular";

console.log("Started JS App Archive");

popular();
